import { firestore } from "../config/firebase";
import ScratchAPIProvider from "./scratchProvider";

export default class FirebaseProvider {
  static getCurrentScratchathon = async () => {
    const query = await firestore
      .collection("events")
      .where("current", "==", true)
      .get();

    const doc = query.docs[0];
    const data = doc.data();

    return { id: doc.id, ...data };
  };

  static getEventProjects = async (eventID) => {
    const query = await firestore
      .collection("events")
      .doc(eventID)
      .collection("projects")
      .get();

    const projectsFirData = [];

    const projectPromises = query.docs.map(async (doc) => {
      projectsFirData.push(doc.data());
      return ScratchAPIProvider.getProjectData(doc.id).catch(function (err) {
        console.error("err", err);
      });
    });

    const projectsScratchData = await Promise.all(projectPromises);
    const validProjectsScratchData = projectsScratchData.filter(
      (result) => typeof result !== "undefined"
    );

    const projectsAllData = validProjectsScratchData.map(
      (projectScratch, i) => {
        return {
          ...projectScratch,
          ...projectsFirData[i],
        };
      }
    );

    return projectsAllData;
  };
}
